import { useState, useEffect } from 'react';
import EmbeddedDashboard from '../../reports/EmbeddedDashboard';
import type { DashboardsResponse } from '../../../api/reports';
import { fetchDashboards } from '../../../api/reports';

export default function MarketingReportsTab() {
  const [config, setConfig] = useState<DashboardsResponse | null>(null);
  const [activeDashboard, setActiveDashboard] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboards()
      .then((data) => {
        setConfig(data);
        if (data.dashboards.marketing.length > 0) {
          setActiveDashboard(data.dashboards.marketing[0].id);
        }
      })
      .catch(() => setConfig(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-8 h-8 border-2 border-moss-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!config || !config.available) {
    return (
      <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-6 text-center">
        <p className="text-sm text-amber-700 dark:text-amber-400 font-medium">Reports not configured</p>
        <p className="text-xs text-amber-600 dark:text-amber-500 mt-1">
          Superset is not configured on this environment.
        </p>
      </div>
    );
  }

  const dashboards = config.dashboards.marketing;

  return (
    <div className="space-y-4">
      {/* Dashboard selector tabs */}
      <div className="flex items-center gap-2">
        {dashboards.map((d) => (
          <button
            key={d.id}
            onClick={() => setActiveDashboard(d.id)}
            className={`px-3 py-1.5 text-xs font-medium rounded-md transition ${
              activeDashboard === d.id
                ? 'bg-moss-600 text-white'
                : 'bg-stone-100 dark:bg-[#242d28] text-stone-600 dark:text-stone-400 hover:bg-stone-200 dark:hover:bg-[#2a352e]'
            }`}
          >
            {d.title}
          </button>
        ))}
      </div>

      {/* Embedded dashboard */}
      {activeDashboard && (
        <EmbeddedDashboard
          dashboardId={activeDashboard}
          supersetUrl={config.supersetUrl}
        />
      )}
    </div>
  );
}
